import React from 'react';
import UserProfilePage from './profile/UserProfilePage';

const MyPage = () => {
  return <UserProfilePage />;
};

export default MyPage;
